import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton } from '@fluentui/react';
import { TranslatableString } from '@rjsf/utils';
export default function FluentIconButton(props) {
    const iconProps = {
        iconName: props.icon,
    };
    return _jsx(IconButton, { disabled: props.disabled, onClick: props.onClick, iconProps: iconProps, color: 'secondary' });
}
export function CopyButton(props) {
    const { registry: { translateString }, } = props;
    return _jsx(FluentIconButton, { title: translateString(TranslatableString.CopyButton), ...props, icon: 'Copy' });
}
export function MoveDownButton(props) {
    const { registry: { translateString }, } = props;
    return (_jsx(FluentIconButton, { title: translateString(TranslatableString.MoveDownButton), ...props, icon: 'Down' }));
}
export function MoveUpButton(props) {
    const { registry: { translateString }, } = props;
    return _jsx(FluentIconButton, { title: translateString(TranslatableString.MoveUpButton), ...props, icon: 'Up' });
}
export function RemoveButton(props) {
    const { registry: { translateString }, } = props;
    return (_jsx(FluentIconButton, { title: translateString(TranslatableString.RemoveButton), ...props, icon: 'Delete' }));
}
//# sourceMappingURL=IconButton.js.map